import { render, staticRenderFns } from "./AddCommodityToWarehouse.vue?vue&type=template&id=78359458&scoped=true&"
import script from "./AddCommodityToWarehouse.vue?vue&type=script&lang=js&"
export * from "./AddCommodityToWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78359458",
  null
  
)

export default component.exports